import { Bot } from 'grts-utils/types/Bot';

import { api } from './api';
import { ApiSubscription, SubscriptionSummary } from '../../types/subscription';

// Compact per-asset series used by the demo dashboard for client-side
// aggregation (the Settings dropdown's exclusion + date window + start-balance
// rebase all live in frontend selectors).
export interface DemoPortfolioSeriesItem {
  baseAsset: string;
  quoteAsset: string;
  startBalanceInUsdt: number;
  startBalanceInAsset: number;
  firstPrice: number;
  dataPoints: { timestamp: number; value: number }[];
  napDataPoints: { timestamp: number; value: number }[];
}

// Userless endpoints backed by SPC result files in data-service. Used only
// when the demo flag is set. See clientDemo.ts in data-service.
//
// Kept in their own injected slice so the main api.ts file is free of demo
// code — only the base reducer/middleware live there.
export const demoApi = api.injectEndpoints({
  endpoints: (builder) => ({
    getDemoSubscriptionSummaries: builder.query<
      { success: boolean; subscriptionSummary: SubscriptionSummary[] },
      void
    >({
      query: () => '/client/demo/summary',
    }),
    getDemoSubscriptionsDetailsBatch: builder.query<
      { success: boolean; subscriptionDetails: ApiSubscription[] },
      { baseAssets: string[] }
    >({
      query: ({ baseAssets }) => ({
        url: '/client/demo/subs/details',
        method: 'POST',
        body: { baseAssets },
      }),
    }),
    getDemoSubscriptionDetails: builder.query<
      { success: boolean; subscriptionDetails: ApiSubscription | null },
      { baseAsset: string }
    >({
      query: ({ baseAsset }) => `/client/demo/sub/details/${baseAsset}`,
    }),
    getDemoBot: builder.query<
      { success: boolean; bot: Bot | null },
      { baseAsset: string }
    >({
      query: ({ baseAsset }) => `/client/demo/bot/${baseAsset}`,
    }),
    getDemoPortfolioSeries: builder.query<
      { success: boolean; series: DemoPortfolioSeriesItem[] },
      void
    >({
      query: () => '/client/demo/portfolio/series',
    }),
  }),
  overrideExisting: false,
});

export const {
  useGetDemoSubscriptionSummariesQuery,
  useGetDemoSubscriptionsDetailsBatchQuery,
  useGetDemoSubscriptionDetailsQuery,
  useGetDemoBotQuery,
  useGetDemoPortfolioSeriesQuery,
} = demoApi;
